import "./js/index.js"
import "./fontawesome.js" // Edit this to add or remove FontAwesome icons
import "./scss/index.scss"